import React from 'react';

import './homepage.styles.scss';

const images = [
  'https://firebasestorage.googleapis.com/v0/b/jiu-jitsu-team-america.appspot.com/o/cover_photo.JPG?alt=media&token=8f58d42e-3606-4815-84d6-846367c20403',
  'https://firebasestorage.googleapis.com/v0/b/jiu-jitsu-team-america.appspot.com/o/cover_photo2.jpg?alt=media&token=db08bb29-7b37-4523-b482-114d4f09b7e1',
]

const Homepage = () => { 
  return (

    <div id="carousel-example-2" class="carousel slide carousel-fade z-depth-1-half" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
        <li data-target="#carousel-example-2" data-slide-to="1"></li>
      </ol>

      <div style={{maxHeight: '1050px'}} class="carousel-inner" role="listbox">
        <div class="carousel-item active">
        <div class="view">
          <img class="d-block w-100" src={images[0]} alt="First slide"/>
          <div class="mask rgba-black-light"></div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="view">
          <img class="d-block w-100" src={images[1]} alt="Second slide"/>
          <div class="mask rgba-black-light"></div>
        </div>
      </div>
    </div>

    <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>

  </div>
)}

export default Homepage;